module.exports = __webpack_public_path__ + "assets/img/32_530_big.cc016c48.jpg";